import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageHome = lazy(() => import("./layout/index"));

export const routerPageHome: RouterItemType = {
  path: "/home",
  authorize: false,
  element: <LayoutPageHome />,
};
